export default __webpack_public_path__ + "static/media/getApp.7b4e86bd.png";